import { Product, WithContext } from 'schema-dts'

export interface AggregateOfferSchemaProps {
	name: string
	image: string
	highPrice: number
	lowPrice: number
	offerCount: number
	offers: string[]
	ratingCount?: number
	reviewCount?: number
	ratingValue?: number
}

export const AggregateOfferSchema = (props: AggregateOfferSchemaProps): WithContext<Product> => {
	const { name, image, highPrice, lowPrice, offerCount } = props

	return {
		'@context': 'https://schema.org',
		'@type': 'Product',
		name: name,
		image: image,
		offers: {
			'@type': 'AggregateOffer',
			priceCurrency: 'RUB',
			highPrice: highPrice,
			lowPrice: lowPrice,
			offerCount: offerCount
			// offers: offers.map(url => ({
			// 	'@type': 'Offer',
			// 	url: url
			// }))
		}
	}
}
